import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="bg-[#FFF8F0] py-20 px-6" data-id="element-168">
      <div className="max-w-4xl mx-auto" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#2D6A4F] rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-xl" data-id="element-170">
          {/* Subtle pattern/glow */}
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.1)_0%,transparent_70%)] pointer-events-none" data-id="element-171"></div>

          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-8 relative z-10" data-id="element-172">
            Qué cambia en 7 días
          </h2>

          <p className="text-[#FFF8F0] text-lg md:text-xl leading-relaxed relative z-10 font-light" data-id="element-173">
            Pasarás de despertarte con ansiedad y culpa a tener un sistema
            predecible. Tus hijos recibirán comida real que les da energía
            estable para estudiar, y tú llegarás a tu primera reunión del día
            con la satisfacción de haber cumplido con ellos y contigo misma.
          </p>
          <p className="text-white font-semibold text-xl mt-6 relative z-10" data-id="element-174">
            Sin estufas sucias, sin sudar antes de vestirte y sin desperdiciar
            comida.
          </p>
        </motion.div>
      </div>
    </section>;
}